import { BrowserCacheLocation, Configuration, PublicClientApplication } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "116c73a5-89ad-4913-8952-bc9075f4e3c0",
    authority: "https://login.microsoftonline.com/045c0c45-3c80-4b73-b52f-42f07d6207d4",
    knownAuthorities: ["https://login.microsoftonline.com"],
    // Default target for silent-renewal iframes and login popups only — must be a static
    // page that does not bootstrap React/MSAL, or the hidden iframe re-inits MSAL and
    // trips block_iframe_reload. Top-level redirect flows override this back to "/".
    redirectUri: "/redirect.html",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    allowRedirectInIframe: false,
  },
};

export const msalApp = new PublicClientApplication(msalConfig);
await msalApp.initialize();
await msalApp.handleRedirectPromise();
